import { fetchCurrency } from 'utils/helperMethods';

export const pricePointParser = (data: any, config: any) => {
    let result: any = {};
    const colors = [...config.graphColorScheme]?.reverse();
    data?.data.forEach((item: any) => {
        let modifiedData = item.attributeList.map((data: any, index: number) => ({
            attributeType: data.attributeName,
            price: `${item.pricePoints?.[1]}`,
            value: data.contribution,
            color: colors?.[index],
            range: item.pricePoints,
        }));

        result[item.bucketNum] = {
            data: modifiedData.reverse(),
            count: item.bucketContribution,
            range: item.pricePoints,
        };
    });
    return result;
};

export const pricePointTableParser = (data: any[], config: any, commonConfig: any) => {
    const currency = fetchCurrency(commonConfig);
    let result: any[] = [];
    const tableHeaderKeyMapping = config?.tableHeaderKeyMapping;
    const colors = [...config.graphColorScheme]?.reverse();
    let parentKey = '';
    let nestedItemIndex = 0;
    result = data?.map((item: any) => {
        if (item?.isExpandable) {
            parentKey = item?.label;
            nestedItemIndex = 0;
        }
        const temp: any = {};
        item?.pricePointsLst?.map((pricePoint: any, index: number) => {
            temp[`${currency}${pricePoint[0]} - ${currency}${pricePoint[1]}`] = {
                value: item?.values?.[index],
                pre: parentKey in tableHeaderKeyMapping ? tableHeaderKeyMapping[parentKey]?.[1] : '',
                post: parentKey in tableHeaderKeyMapping ? tableHeaderKeyMapping[parentKey]?.[2] : '',
            };
        });
        return {
            label: item?.label in tableHeaderKeyMapping ? tableHeaderKeyMapping[item?.label]?.[0] : item?.label,
            ...temp,
            isExpandable: item?.isExpandable,
            nestedIndex: item?.nestedIndex,
            color: item?.isExpandable ? null : colors?.[nestedItemIndex++],
        };
    });
    return result;
};

export const pricePointDrilldownTableParser = (data: any[], config: any) => {
    try {
        const tableHeaderKeyMapping = config?.drilldownTableHeaderKeyMapping;

        let result: any[] = [];
        const parsedItem = JSON.parse(data?.[0]);
        if (parsedItem) {
            for (let i in parsedItem) {
                const temp: any = {};
                if (i !== 'label') {
                    temp['label'] = i;
                    Object.keys(tableHeaderKeyMapping)?.map((item, index: number) => {
                        const parsedDataItem = JSON.parse(data?.[index]);
                        temp[tableHeaderKeyMapping[item]?.[0]] = {
                            pre: tableHeaderKeyMapping[item]?.[1] || '',
                            post: tableHeaderKeyMapping[item]?.[2] || '',
                            val: parsedDataItem[i],
                        };
                    });
                    result.push(temp);
                }
            }
        }
        // const result = data?.map((item: any) => {
        //     const parsedItem = JSON.parse(item);
        //     console.log(parsedItem, 'logging data');
        //     const temp: any = {};
        //     for (let i in parsedItem) {
        //         if (i !== 'label') {
        //             temp[i] = {
        //                 pre:
        //                     parsedItem?.label in tableHeaderKeyMapping
        //                         ? tableHeaderKeyMapping[parsedItem?.label]?.[1]
        //                         : '',
        //                 post:
        //                     parsedItem?.label in tableHeaderKeyMapping
        //                         ? tableHeaderKeyMapping[parsedItem?.label]?.[2]
        //                         : '',
        //                 val: parsedItem[i],
        //             };
        //         }
        //     }

        //     return {
        //         label:
        //             parsedItem?.label in tableHeaderKeyMapping
        //                 ? tableHeaderKeyMapping[parsedItem?.label]?.[0]
        //                 : parsedItem?.label,
        //         ...temp,
        //     };
        // });

        return result;
    } catch (error) {
        throw error;
    }
};
